import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiCalendar, FiMenu, FiX, FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { motion } from "framer-motion";
import { FaFacebook, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa6";

const navContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.25,
    },
  },
};

const navItem = {
  hidden: {
    y: -20,
    opacity: 0,
    filter: "blur(8px)",
  },
  visible: {
    y: 0,
    opacity: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
  document.body.style.overflow = menuOpen ? "hidden" : "auto";

  return () => {
    document.body.style.overflow = "auto";
  };
}, [menuOpen]);

  return (
    <>
    <motion.header
      layout
      transition={{ duration: 0.45 }}
      className={`header ${scrolled ? "scrolled" : ""}`}
    >
      <div className="container header-container">

        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, x: -35 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          <Link to="/" className="logo">
            <motion.img
              src="/logo.svg"
              alt="Onbbits Logo"
              whileHover={{
                scale: 1.05,
              }}
              transition={{
                type: "spring",
                stiffness: 300,
                damping: 15,
              }}
            />
          </Link>
        </motion.div>

        <div className="header-right">

          {/* Navigation */}
          <motion.nav
    className="nav-links desktop-nav"
    variants={navContainer}
    initial="hidden"
    animate="visible"
  >
            {[
              { to: "/", label: "Home" },
              { to: "/features", label: "Features" },
              { to: "/industries", label: "Industries" },
              { to: "/pricing", label: "Pricing" },
              { to: "/about-us", label: "About" },
              { to: "/blog", label: "Blog" },
            ].map((item) => (
              <motion.div
                key={item.label}
                variants={navItem}
                whileHover={{
                  y: -2,
                }}
                transition={{
                  type: "spring",
                  stiffness: 400,
                  damping: 18,
                }}
              >
                <NavLink to={item.to}>{item.label}</NavLink>
              </motion.div>
            ))}
          </motion.nav>

          {/* Buttons */}
          <motion.div
            className="header-buttons"
            initial={{
              opacity: 0,
              x: 40,
              filter: "blur(10px)",
            }}
            animate={{
              opacity: 1,
              x: 0,
              filter: "blur(0px)",
            }}
            transition={{
              delay: 0.55,
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <motion.div
              whileHover={{
                y: -3,
                scale: 1.03,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                type: "spring",
                stiffness: 350,
                damping: 18,
              }}
            >
              <Link  to="/book-a-demo" className="btn btn-demo">
                <motion.span
                  animate={{
                    rotate: [0, -10, 10, 0],
                  }}
                  transition={{
                    repeat: Infinity,
                    repeatDelay: 1,
                    duration: 0.8,
                  }}
                >
                  <FiCalendar />
                </motion.span>

                <span>Book a Demo</span>
              </Link>
            </motion.div>

            <motion.div
              whileHover={{
                y: -3,
                scale: 1.03,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                type: "spring",
                stiffness: 350,
                damping: 18,
              }}
            >
              <a href="https://app.onbbits.io/register"
                target="_blank"
                rel="noreferrer" className="btn btn-primary">
                Get Started For Free
              </a>
            </motion.div>
          </motion.div>
               <button
    className="hamburger"
    onClick={() => setMenuOpen(true)}
  >
    <FiMenu />
  </button>

        </div>
      </div>
    </motion.header>

    <div
  className={`sidebar-overlay ${menuOpen ? "active" : ""}`}
  onClick={() => setMenuOpen(false)}
></div>

    <div className={`mobile-sidebar ${menuOpen ? "active" : ""}`}>

  <div className="sidebar-top">

    <Link to="/" onClick={() => setMenuOpen(false)}>
      <img
        src="/logo.svg"
        alt="Onbbits Logo"
      />
    </Link>

    <button
      type="button"
      className="close-btn"
      onClick={() => setMenuOpen(false)}
    >
      <FiX />
    </button>

  </div>

  <nav className="sidebar-links">

    <NavLink to="/" onClick={() => setMenuOpen(false)}>
      Home
    </NavLink>

    <NavLink to="/features" onClick={() => setMenuOpen(false)}>
      Features
    </NavLink>

    <NavLink to="/industries" onClick={() => setMenuOpen(false)}>
      Industries
    </NavLink>

    <NavLink to="/pricing" onClick={() => setMenuOpen(false)}>
      Pricing
    </NavLink>

    <NavLink to="/about-us" onClick={() => setMenuOpen(false)}>
      About
    </NavLink>

    <NavLink to="/blog" onClick={() => setMenuOpen(false)}>
      Blog
    </NavLink>

     <NavLink to="/contact-us" onClick={() => setMenuOpen(false)}>
      Contact Sales
    </NavLink>

  </nav>

  <div className="sidebar-buttons">

    <Link
      to="/book-a-demo"
      className="btn btn-demo"
      onClick={() => setMenuOpen(false)}
    >
      <FiCalendar />
      <span>Book a Demo</span>
    </Link>

    <a
      href="https://app.onbbits.io/register"
      target="_blank"
      rel="noreferrer"
      className="btn btn-primary"
      onClick={() => setMenuOpen(false)}
    >
      Get Started For Free
    </a>

  </div>

  <div className="sidebar-contact">

    <div className="sidebar-contact-item">
      <FiPhone />
      <span>+91 97270 77732</span>
    </div>

    <div className="sidebar-contact-item">
      <FiMail />
      <span>info@onbbits.io</span>
    </div>

    <div className="sidebar-contact-item">
      <FiMapPin />
      <span>912, International Finance Center, Surat</span>
    </div>

  </div>

  <div className="sidebar-social">

    <a href="https://www.facebook.com/onbbits"
                target="_blank" rel="noreferrer" aria-label="Facebook">
      <FaFacebook />
    </a>

    <a   href="https://www.linkedin.com/company/onbbits"
                target="_blank" rel="noreferrer" aria-label="LinkedIn">
      <FaLinkedinIn />
    </a>

    <a  href="https://www.instagram.com/onbbits_"
                target="_blank" rel="noreferrer" aria-label="Instagram">
      <FaInstagram />
    </a>

    <a href="https://www.youtube.com/@Onbbits"
                target="_blank" rel="noreferrer" aria-label="YouTube">
     <FaYoutube />
    </a>

  </div>

</div>
</>
  );
};

export default Header;